// La portada acompaña la salida; la navegación sigue siendo un enlace nativo.
(() => {
  let moving = false;
  let floating;
  let original;
  function reset() {
    floating?.remove();
    if (original) original.style.visibility = '';
    moving = false;
  }
  window.addEventListener('pageshow', reset);
  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('.av-cover a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.href === location.href || destination.hash || innerWidth <= 750 || window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    original = document.querySelector('.av-cover .av-footer-seal');
    if (!original || !original.animate) return;
    event.preventDefault();
    if (moving) return;
    moving = true;
    const box = original.getBoundingClientRect();
    const style = getComputedStyle(original);
    floating = document.createElement('div');
    floating.textContent = original.textContent;
    floating.setAttribute('aria-hidden', 'true');
    Object.assign(floating.style, { position: 'fixed', top: `${box.top}px`, left: `${box.left}px`, width: `${box.width}px`, margin: '0', color: style.color, font: style.font, letterSpacing: style.letterSpacing, lineHeight: style.lineHeight, whiteSpace: 'nowrap', pointerEvents: 'none', zIndex: '9999' });
    document.body.append(floating);
    original.style.visibility = 'hidden';
    try {
      const landing = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--av-seal-top')) || 57;
      await floating.animate([{ transform: 'translateY(0)' }, { transform: `translateY(${landing - box.top}px)` }], { duration: 500, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' }).finished;
    } finally {
      location.assign(destination.href);
    }
  });
})();
